export * from './constants.base';

export const SHOW_PHONE_INPUT_INSIDE_OPTIONAL_INFO = true;
